import chalk from "chalk";

export const highlighter = {
  error: chalk.red,
  warn: chalk.yellow,
  info: chalk.cyan,
  infoBright: chalk.cyanBright,
  success: chalk.greenBright,
  underline: chalk.underline,
  title: chalk.bgBlue,
};
